import { gsap } from "gsap";


export default class CastModal {
    constructor() {
        this._init();
    }

    show(key) {
        this.$nowCast = document.querySelector(`.castmodal__item.-${key}`);
        this.$nowCast.classList.add("-active");
        this.$modal.classList.add("-active");
        this._pageFix();
    }

    hide() {
        this.$nowCast.classList.remove("-active");
        this.$modal.classList.remove("-active");
        this._pageRet();
    }

    _init() {
        this.sy = 0;

        this.$wrapper = document.querySelector(".l-wrapper");
        this.$nowCast = null;
        this.$modal = document.querySelector(".castmodal");
        this._ui();
    }

    _ui() {
        const openList = [...document.querySelectorAll(".js-modal-open")];

        openList.forEach(($open) => {
            $open.addEventListener("click", () => {
                const key = $open.getAttribute("data-key");
                this.show(key);
            });

            $open.addEventListener("mouseover", () => {
                const key = $open.getAttribute("data-key");
                const $item = document.querySelector(
                    `.castbox__names__item.-${key}`
                );
                gsap.to($item, {
                    duration: 0.3,
                    scale: 1.2,
                    ease: "back.out(1)",
                });
            });

            $open.addEventListener("mouseout", () => {
                const key = $open.getAttribute("data-key");
                const $item = document.querySelector(
                    `.castbox__names__item.-${key}`
                );
                gsap.to($item, {
                    duration: 0.3,
                    scale: 1,
                    ease: "back.out(1)",
                });
            });
        });

        document
            .querySelector(".castmodal__close")
            .addEventListener("click", () => {
                this.hide();
            });
    }

    _pageFix() {
        this.sy = window.scrollY;
        this.$wrapper.style.position = "fixed";
        this.$wrapper.style.top = `-${this.sy}px`;
        window.scrollTo(0, 0);
    }

    _pageRet() {
        this.$wrapper.style.position = "relative";
        this.$wrapper.style.top = 0;
        window.scrollTo(0, this.sy);
    }
}